export const cacheKeys = {
  getHubProfile: 'getHubProfile',
  updateHubGoals: 'updateHubGoals',
  getModules: 'getModules',
  getEducationProgress: 'getEducationProgress',
  markVideoWatched: 'markVideoWatched',
  gradeQuiz: 'gradeQuiz',
  getProfilePhotos: 'getProfilePhotos',
  getUtilityBill: 'getUtilityBill',
  getUtilityStatus: 'getUtilityStatus',
  getUtilityBills: 'getUtilityBills',
  connectUtility: 'connectUtility',
  uploadProfileFile: 'uploadProfileFile',
  getReadiness: 'getReadiness',
  getEnergyPrices: 'getEnergyPrices',
  getRecentActivity: 'getRecentActivity',
  recordExplore: 'recordExplore',
  getProjectBoard: 'getProjectBoard',
  projectBoardMutation: 'projectBoardMutation',
  getConsultation: 'getConsultation',
  recordConsultation: 'recordConsultation',
  sendMessage: 'sendMessage',
};
